// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-TransformContainer-module--cls1--xm9AU","cls2":"styles-TransformContainer-module--cls2--3EvoI styles-TransformContainer-module--cls1--xm9AU"};